// src/core/base-services.js
import EventManager from "../../core/event-bus";

/**
 * 直播服务抽象基类
 */
export class BaseLiveService {
  constructor() {
    if (new.target === BaseLiveService) {
      throw new Error("Cannot instantiate abstract class BaseLiveService");
    }
    this.eventManager = new EventManager();
    this.client = null;
    this.isEnterRoomSuccess = false;
  }
  // 事件相关方法
  on(eventName, callback) {
    return this.eventManager.on(eventName, callback);
  }

  once(eventName, callback) {
    return this.eventManager.once(eventName, callback);
  }
  /**
   *
   * @param {*} eventName
   * @param {*} callback
   * @returns
   */
  off(eventName, callback) {
    return this.eventManager.off(eventName, callback);
  }

  // 受保护的方法，供子类调用以触发事件
  _emit(eventName, data) {
    this.eventManager.emit(eventName, data);
  }
  /**
   * 进入直播间
   * @returns {Promise<>}
   */
  enterRoom() {}
  /**
   * 退出直播间
   * @returns {Promise<>}
   */
  exitRoom() {}
  // ----------------------------------------------------摄像头相关--------------------------------------
  /**
   * 获取摄像头列表
   * @returns {Promise<Array>} 返回摄像头列表
   * @property {Array} cameras - 摄像头列表
   * @property {string} cameras[].deviceId - 摄像头的ID
   * @property {string} cameras[].deviceName - 摄像头的名称
   * @property {string} cameras[].deviceProperties - 设备属性
   * @abstract
   */
  getCameraList() {
    throw new Error("Method getCameraList() must be implemented by subclass");
  }
  /**
   * 获取当前摄像头设备
   * @returns {Object || null} 返回当前摄像头设备
   * @property {string} deviceId - 摄像头的ID
   * @property {string} deviceName - 摄像头的名称
   * @abstract
   */
  getCurrentCameraDevice() {
    throw new Error(
      "Method getCurrentCameraDevice() must be implemented by subclass"
    );
  }
  /**
   * 开始本地摄像头预览
   * @param {Object} params - 预览参数
   * @param {HTMLElement} params.dom - 预览的DOM元素
   * @param {boolean} params.publish - 是否发布
   * @returns {Promise<void>}
   * @abstract
   */
  startLocalPreview({ dom, publish = false }) {
    throw new Error(
      "Method startLocalPreview() must be implemented by subclass"
    );
  }

  /**
   * 切换摄像头
   * @param {Object} params
   * @param {string} params.deviceId - 设备ID
   */
  setCurrentCameraDevice(params) {
    throw new Error(
      "Method setCurrentCameraDevice() must be implemented by subclass"
    );
  }
  /**
   * 停止本地摄像头采集
   * @returns {Promise<void>}
   */
  stopLocalPreview() {
    throw new Error(
      "Method stopLocalPreview() must be implemented by subclass"
    );
  }
  /**
   * 暂停或者恢复本地视频采集
   * @param {Object} params
   * @param {boolean} params.mute
   * @returns {Promise<void>}
   */
  muteLocalVideo(params) {
    throw new Error(
      "Method stopLocalPreview() must be implemented by subclass"
    );
  }
  /**
   * 开始显示远端视频画面
   * @param {*} params
   * @param {string} params.userID - 用户ID
   * @param {number} params.streamType - 视频流类型
   * @param  {HTMLElement} params.view - 视频的DOM元素
   */

  startRemoteView(params) {
    throw new Error("Method startRemoteView() must be implemented by subclass");
  }
  /**
   * 停止显示远端视频画面
   * @param {*} params
   * @param {string} params.userID - 用户ID
   * @param {number} params.streamType - 视频流类型

   */
  stopRemoteView(params) {
    throw new Error("Method stopRemoteView() must be implemented by subclass");
  }
  /**
   * 更新远端
   * @param {*} params
   * @param {string} params.userID - 用户ID
   * @param {number} params.streamType - 视频流类型
   * @param  {HTMLElement} params.view - 视频的DOM元素
   */

  updateRemoteVideo(param) {
    throw new Error(
      "Method updateRemoteVideo() must be implemented by subclass"
    );
  }
  // ----------------------------------------------------麦克风相关--------------------------------------
  /**
   * 获取麦克风列表
   * @returns {Promise<Array>} 麦克风列表
   * @property {Array} micro - 麦克风列表
   * @property {string} micro[].deviceId - 麦克风的ID
   * @property {string} micro[].deviceName - 麦克风的名称
   * @property {string} micro[].deviceProperties - 设备属性
   */
  getMicrophoneList() {
    throw new Error(
      "Method getMicrophoneList() must be implemented by subclass"
    );
  }
  /**
   * 开启本地麦克风采集，并发布到当前的房间中。
   * @returns {Promise<any>}
   */
  startLocalAudio() {
    throw new Error("Method startLocalAudio() must be implemented by subclass");
  }
  /**
   * 停止本地麦克风的采集及发布
   * @returns {Promise<any>}
   */
  stopLocalAudio() {
    throw new Error("Method stopLocalAudio() must be implemented by subclass");
  }
  /**
   * 切换麦克风
   * @param {Object} params
   * @param {string} params.deviceId
   * @returns {Promise<void>}
   */
  setCurrentMicDevice(params) {
    throw new Error(
      "Method setCurrentMicDevice() must be implemented by subclass"
    );
  }
  /**
   * 麦克风静音/开启
   * @param {Object} params
   * @param {boolean} params.mute
   */
  muteLocalAudio(params) {
    throw new Error("Method muteLocalAudio() must be implemented by subclass");
  }
  /**
   * 静音某个远端用户的音频，只对当前用户有效
   * @param {Object} params
   * @param {string} params.userId
   * @param {boolean} params.mute
   */
  muteRemoteAudio(params) {
    throw new Error("Method muteRemoteAudio() must be implemented by subclass");
  }
  /**
   * 开启本地麦克风测试
   *@returns void
   */
  startMicDeviceTest(params) {
    throw new Error(
      "Method startMicDeviceTest() must be implemented by subclass"
    );
  }
  /**
   * 停止本地麦克风测试
   *@returns void
   */
  stopMicDeviceTest() {
    throw new Error(
      "Method stopMicDeviceTest() must be implemented by subclass"
    );
  }
  /**
   * 开启音量检测
   * @param {Object} params
   * @param {number} params.interval
   */
  enableAudioVolumeEvaluation(params) {
    throw new Error(
      "Method enableAudioVolumeEvaluation() must be implemented by subclass"
    );
  }
  // ----------------------------------------------------扬声器相关--------------------------------------
  /**
   * 获取扬声器设备列表;
   * @returns {Promise<Array>}
   *
   */

  getSpeakerDevicesList() {
    throw new Error(
      "Method getSpeakerDevicesList() must be implemented by subclass"
    );
  }
  /**
   * 切换扬声器
   * @param {Object} params
   * @param {string} params.deviceId
   * @returns {Promise<void>}
   */
  setCurrentSpeakerDevice(params) {
    throw new Error(
      "Method setCurrentSpeakerDevice() must be implemented by subclass"
    );
  }
  /**
   * 设置系统当前扬声器设备音量 设置的扬声器音量，范围0 - 100
   * @param {Object} params
   * @param {number} params.volume
   */
  setCurrentSpeakerVolume() {
    throw new Error(
      "Method setCurrentSpeakerVolume() must be implemented by subclass"
    );
  }
  // ----------------------------------------------------屏幕共享相关--------------------------------------
  /**
   * 启动屏幕共享
   * @returns {Promise<void>}
   */
  startScreenCapture() {
    throw new Error(
      "Method startScreenCapture() must be implemented by subclass"
    );
  }

  // ----------------------------------------------------消息相关--------------------------------------
  /**
   * 发送自定义消息
   * @param  {Object} params
   * @param  {Number} params.cmdId 消息 Id
   * @param  {String} params.data 消息内容
   */
  sendCustomMessage(params) {
    throw new Error(
      "Method sendCustomMessage() must be implemented by subclass"
    );
  }

  setVideoMuteImage() {}

  // 获取当前选择的麦克风
  getCurrentMicDevice() {}

  //设置系统当前麦克风设备的音量。麦克风音量值，volume 范围0 - 100
  setCurrentMicDeviceVolume(volume) {}
  // 设置系统当前麦克风设备的静音状态;mute设置为 true 时，麦克风设备静音；设置为 false时，麦克风设备取消静音
  setCurrentMicDeviceMute(mute) {}
  // 获取系统当前麦克风设备是否静音
  getCurrentMicDeviceMute() {}

  //获取当前的扬声器设备
  getCurrentSpeakerDevice() {}
  // 获取系统当前扬声器设备音量;
  getCurrentSpeakerVolume() {}
  // 设置系统当前扬声器设备的静音状态 mute设置为 true 时，扬声器设备静音；设置为 false时，扬声器设备取消静音
  setCurrentSpeakerDeviceMute() {}

  // 枚举可共享的窗口列表
  getScreenCaptureSources() {}

  //镜像
  setMirror(tag) {
    throw new Error("Method setMirror() must be implemented by subclass");
  }
  // 测试摄像头——只预览不发布
  startLocalPreviewByTestClient(params) {
    throw new Error(
      "Method startLocalPreviewByTestClient() must be implemented by subclass"
    );
  }
  // 开启美颜
  startBasicBeauty() {
    throw new Error(
      "Method startBasicBeauty() must be implemented by subclass"
    );
  }
  //关闭美颜
  stopBasicBeauty() {
    throw new Error("Method stopBasicBeauty() must be implemented by subclass");
  }
  //更新美颜
  updateBasicBeauty(params) {
    throw new Error(
      "Method updateBasicBeauty() must be implemented by subclass"
    );
  }
  //初始化美颜
  initBasicBeauty() {
    throw new Error("Method initBasicBeauty() must be implemented by subclass");
  }
  // 控制远端音频的播放音量
  setRemoteAudioVolume({ userId = "*", volume = 100 }) {
    throw new Error(
      "Method setRemoteAudioVolume() must be implemented by subclass"
    );
  }

  // 设置私有mapKey
  switchRole(role, option = {}) {
    throw new Error(
      "Method setPrivateMapKey() must be implemented by subclass"
    );
  }
}
